import { Modal, RadioGroup } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { CalibrationMode, CalibrationTypeDict } from 'enums/CalibrationMode';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useInjection } from 'services/ioc/ioc.react';
import { FieldCalibrationStore } from 'stores/FieldCalibrationStore';
import { SessionStore } from 'stores/SessionStore';
import WizardStore from 'stores/WizardStore';
import { buttonLightGrey, darkgrey } from 'styles/Colors';
import { Description, ModalContent, RadioWrapper, StyledRadio } from './styles/CalibrationConfirmModalStyles';

interface IProps {}

export const CalibrationConfirmModal: React.FC<IProps> = observer((props) => {
  const fieldCalibrationStore = useInjection<FieldCalibrationStore>(ServiceTypes.FieldCalibrationStore);
  const wizardStore = useInjection<WizardStore>(ServiceTypes.WizardStore);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);
  const history = useHistory();
  const [calibrationType, setCalibrationType] = useState(CalibrationMode.Homeplate);

  const stopBouncingBallCalibrationSession = async (): Promise<void> => {
    await sessionStore.submitCalibration({
      ...sessionStore.currentSessionMetadata,
      calibration: {
        bounceWithin5FeetFromHomePlateCount: fieldCalibrationStore.bounceWithin5FeetFromHPCount,
        calibrationMode: calibrationType,
        hitCount: fieldCalibrationStore.totalCount,
        hitHomePlateCount: fieldCalibrationStore.hitHPCount,
      },
    });
  };

  const onCloseHandler = () => {
    fieldCalibrationStore.setCalibrationConfirmModalVisible(false);
  };

  const onConfirmHandler = async () => {
    await stopBouncingBallCalibrationSession().then(() => {
      wizardStore.reset();
      fieldCalibrationStore.reset();
      fieldCalibrationStore.setCalibrationConfirmModalVisible(false);
      history.push('/');
    });
  };

  return (
    <Modal
      open={fieldCalibrationStore.calibrationConfirmModalVisible}
      title='Select calibration mode'
      titleCenter
      onClose={onCloseHandler}
      confirmBtn={{
        onClick: onConfirmHandler,
        label: 'Confirm',
      }}
      cancelBtn={{
        onClick: onCloseHandler,
        label: 'cancel',
        style: {
          backgroundColor: buttonLightGrey,
          color: darkgrey,
        },
      }}
      maxWidth={'xs'}
      fullWidth
    >
      <ModalContent>
        <Description>Which target was used for calibration?</Description>
        <RadioGroup>
          <RadioWrapper>
            <StyledRadio
              reversed
              checked={calibrationType === CalibrationMode.Homeplate}
              label={CalibrationTypeDict[CalibrationMode.Homeplate]}
              onChange={() => setCalibrationType(CalibrationMode.Homeplate)}
            />
            <StyledRadio
              reversed
              checked={calibrationType === CalibrationMode.LandingArea}
              label={CalibrationTypeDict[CalibrationMode.LandingArea]}
              onChange={() => setCalibrationType(CalibrationMode.LandingArea)}
            />
            <StyledRadio
              reversed
              checked={calibrationType === CalibrationMode.Neither}
              label={CalibrationTypeDict[CalibrationMode.Neither]}
              onChange={() => setCalibrationType(CalibrationMode.Neither)}
            />
          </RadioWrapper>
        </RadioGroup>
      </ModalContent>
    </Modal>
  );
});
